import Header from '@/pages/home/components/Header';
import Footer from '@/pages/home/components/Footer';

export default function Terms() {
  return (
    <div className="min-h-screen bg-white text-ink-900 antialiased">
      <Header />
      <main className="pt-28 md:pt-36 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-display text-4xl md:text-5xl font-bold text-ink-900 tracking-tight">Terms of Service</h1>
          <p className="mt-4 text-ink-600">Last updated: August 3, 2026</p>

          <div className="mt-10 space-y-8 text-ink-700 leading-relaxed">
            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">1. Acceptance of Terms</h2>
              <p>By accessing and using BuyWize (&ldquo;the site&rdquo;), you agree to be bound by these Terms of Service. If you do not agree with any part of these terms, please discontinue use of the site. BuyWize is operated by an individual site operator, not a registered company.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">2. Eligibility</h2>
              <p>You must be at least 18 years old, or the age of majority in your jurisdiction, to use this site. By using BuyWize, you represent that you meet this requirement.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">3. Content and Reviews</h2>
              <p>All content on BuyWize, including product reviews, comparisons, and buying guides, is provided for general informational purposes only and does not constitute professional or purchasing advice. While we strive for accuracy, product prices, availability, and specifications may change without notice and may not always match the retailer's current listing. Always verify details with the retailer before making a purchase.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">4. Affiliate Disclosure</h2>
              <p>BuyWize participates in affiliate marketing programs, including the Amazon Associates program. When you click on product links and make a qualifying purchase, we may earn a commission at no additional cost to you. This does not affect our editorial independence or review integrity.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">5. Intellectual Property</h2>
              <p>The text, design, and original editorial content on BuyWize belong to the site operator unless otherwise noted, and may not be reproduced or republished without permission. Product names, images, logos, and trademarks referenced on this site belong to their respective owners and are used for identification and review purposes only; their use does not imply any endorsement of BuyWize.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">6. User Conduct</h2>
              <p>Users agree not to misuse the site, including but not limited to attempting unauthorized access, transmitting malware, scraping or bulk-harvesting content without permission, or engaging in any activity that disrupts site functionality. We reserve the right to restrict access to users who violate these terms.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">7. Third-Party Links</h2>
              <p>BuyWize links to third-party retailer sites (such as Amazon) where purchases actually take place. We do not control, and are not responsible for, the content, policies, security, availability, or transactions of any third-party site. Any purchase you make on a retailer's site is governed solely by that retailer's own terms and policies.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">8. Disclaimer of Warranties</h2>
              <p>BuyWize is provided &ldquo;as is&rdquo; and &ldquo;as available,&rdquo; without warranties of any kind, whether express or implied, including but not limited to accuracy, completeness, or fitness for a particular purpose.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">9. Limitation of Liability</h2>
              <p>To the fullest extent permitted by law, the site operator is not liable for any direct, indirect, incidental, or consequential damages arising from your use of the site, reliance on its content, or any transaction with a third-party retailer, including purchase decisions made based on our content.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">10. Indemnification</h2>
              <p>You agree to indemnify and hold the site operator harmless from any claim or demand arising out of your misuse of the site or your violation of these Terms.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">11. Termination</h2>
              <p>We may suspend or terminate your access to the site at any time, without notice, for conduct that violates these Terms or is otherwise harmful to other users or the site.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">12. Governing Law &amp; Severability</h2>
              <p>These Terms do not designate a specific state or country of governing law. If any provision of these Terms is found unenforceable under the law applicable to you, that provision will be limited or removed to the minimum extent necessary, and the remaining provisions will remain in full effect.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">13. Changes to Terms</h2>
              <p>We may update these Terms of Service from time to time. Continued use of the site after changes constitutes acceptance of the updated terms. The latest version will always be available on this page.</p>
            </section>

            <section>
              <h2 className="font-display text-2xl font-bold text-ink-900 mb-3">14. Contact Us</h2>
              <p>If you have questions about these Terms, reach out to us at <a href="mailto:hello@buywize.net" className="text-cta-600 hover:text-cta-700 underline">hello@buywize.net</a>.</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}